// Foundations
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

// Services
import { BookingService } from '@app/services/booking.service';
import { AnalyticsService } from '@app/services/analytics.service';

// Models
import { Item } from '@app/services/graphql.service';
import { ParsedBooking } from '@app/models/booking.model';

@Component({
  selector: 'app-bookings-details',
  templateUrl: './bookings-details.component.html',
  styleUrls: ['./bookings-details.component.scss'],
})
export class BookingsDetailsComponent implements OnInit {
  booking: ParsedBooking;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bookingService: BookingService,
    private _analytics: AnalyticsService,
    private _location: Location
  ) {}

  displayCancel = false;

  ngOnInit() {
    this._analytics.logScreen('upcomingBookingDetailsPage');
    // if we have no booking selected return to the upcoming list
    if (!this.bookingService.selectedBooking) {
      this.router.navigate(['/upcoming-bookings']);
    } else {
      this.booking = this.bookingService.selectedBooking;
    }
    // show cancel info if isCancel param = true
    this.displayCancel = this.route.snapshot.queryParams.isChange === 'true';
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  getServiceTitle(item: Item) {
    return item.displayName.charAt(0) === '.'
      ? // remove leading period
        item.displayName.substring(1)
      : item.displayName;
  }

  callToCancel() {
    this._analytics.logButtonTap('upcomingBooking_callToChangeCancel');
  }

  goBack() {
    this._location.back();
  }
}
